<div class="exploring-evolution-criteria-card mb-3">
  <p class="f-16 font-weight-600 text-black mb-3">
  Craft smart Webbtree Autopilot<sup><span>AI</span></sup> Evaluation Criteria
  </p>
  <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel" data-interval="2000">
  <ol class="carousel-indicators">
    <li data-bs-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
    <li data-bs-target="#carouselExampleCaptions" data-slide-to="1"></li>
    <li data-bs-target="#carouselExampleCaptions" data-slide-to="2"></li>
    <li data-bs-target="#carouselExampleCaptions" data-slide-to="3"></li>
    <li data-bs-target="#carouselExampleCaptions" data-slide-to="4"></li>
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="../../../assets/ai-sourcing/Group48097963.svg" class="d-block w-100" alt="...">

    </div>
    <div class="carousel-item">
      <img src="../../../assets/ai-sourcing/Group48097961.svg" class="d-block w-100" alt="...">

    </div>
    <div class="carousel-item">
      <img src="../../../assets/ai-sourcing/Group48097960.svg" class="d-block w-100" alt="...">

    </div>
    <div class="carousel-item">
      <img src="../../../assets/ai-sourcing/Group48097962.svg" class="d-block w-100" alt="...">

    </div>
    <div class="carousel-item">
      <img src="../../../assets/ai-sourcing/Group48097964.svg" class="d-block w-100" alt="...">

    </div>
  </div>
  <button data-testid="auto-app-evaluation-slider-button-1" class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </button>
  <button data-testid="auto-app-evaluation-slider-button-2" class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </button>
</div>
</div>
